// extracted by mini-css-extract-plugin
export default {"measure":"measure___Q29Gt"};